import { render, staticRenderFns } from "./ClassCompleteDetail.vue?vue&type=template&id=1608e3bf&scoped=true"
import script from "./ClassCompleteDetail.vue?vue&type=script&lang=js"
export * from "./ClassCompleteDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassCompleteDetail.vue?vue&type=style&index=0&id=1608e3bf&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608e3bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1608e3bf')) {
      api.createRecord('1608e3bf', component.options)
    } else {
      api.reload('1608e3bf', component.options)
    }
    module.hot.accept("./ClassCompleteDetail.vue?vue&type=template&id=1608e3bf&scoped=true", function () {
      api.rerender('1608e3bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/ClassCompleteDetail.vue"
export default component.exports